import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';

export default function RevenueExpense({ onComplete }) {
  const [showP, setShowP] = useState(false);

  useEffect(() => {
    const timeouts = [];
    
    timeouts.push(setTimeout(() => setShowP(true), 500));
    timeouts.push(setTimeout(() => onComplete?.(), 9500));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Principles</h1>
      
      <p className={getAnimationClass(showP)}>
        In this level, you'll practice both revenue and expense recognition principles by deciding if a transaction impacts profits. 
      </p>
    </>
  );
}